/**
 * Local next-track advance for background tabs (car / lock-screen).
 * play() must run on the same turn as near-end/ended — never after stats or fetch.
 */
import type { Track } from "@memes/shared";
import { findNextPlayableIndex, type ActiveOwnersMap } from "@memes/shared";

export function nextBackgroundAdvance(state: {
  queue: readonly Track[];
  index: number;
  activeOwners: ActiveOwnersMap;
}): { index: number; track: Track } | null {
  const nextIdx = findNextPlayableIndex(state.queue, state.index + 1, state.activeOwners);
  if (nextIdx == null) return null;
  const nextTrack = state.queue[nextIdx];
  if (!nextTrack) return null;
  return { index: nextIdx, track: nextTrack };
}

export function runBackgroundAdvance(opts: {
  playNext: () => void;
  notifyServer: () => Promise<unknown>;
  recordStats: () => Promise<unknown>;
}): void {
  opts.playNext();
  void opts.notifyServer();
  void opts.recordStats();
}

export function shouldTreatElementPauseAsUserPause(opts: {
  documentHidden: boolean;
  applyingRemote: boolean;
  advancing: boolean;
  elementEnded: boolean;
}): boolean {
  if (
    opts.documentHidden ||
    opts.applyingRemote ||
    opts.advancing ||
    opts.elementEnded
  ) {
    return false;
  }
  return true;
}
